import angular from 'angular';
import ngRoute from 'angular-route';
import booksMenu from '../../menu/Menu';
/** Templates */
import printTemplate from './templates/print.template.html';
import selectTemplate from './templates/select.template.html';

export default angular
  .module('printChecks', [booksMenu, ngRoute])
  .config(printChecksConfig)
  .factory('PrintCheckService', printCheckServiceFactory)
  .controller('mainController', mainController)
  .controller('printChecksController', printChecksController)
  .controller('selectChecksController', selectChecksController)
  .name;
  
  
/*****************************************************************************
 * Config:
 *
 * Configure app routes.
 *****************************************************************************/
/* @ngInject */ function printChecksConfig($routeProvider) {
  $routeProvider
    .when('/', {
      template: selectTemplate,
      controller: 'selectChecksController'
    })
    .when('/print/', {
      template: printTemplate,
      controller: 'printChecksController'
    })
    .otherwise({ redirectTo: '/' });
}


/*******************************************************************************
 * Controller: mainController
 *
 * Main controller for the Print Checks app. Looks for the restrict check print
 * date app flag and disables BusyScreen to start the app.
 *******************************************************************************/
/* @ngInject */ function mainController($appFlags, $scope, BusyScreen, PrintCheckService, BooksSvc) {
  /*---------------*/
  /* SWF/App Flags */
  /*---------------*/
  /** Restrict Print Date. */ 
  var mRestrictCheckPrintDate = $appFlags.restrictCheckPrintDate;
  PrintCheckService.setAppFlags({
    restrictCheckPrintDate: mRestrictCheckPrintDate
  });

  BusyScreen.setBusy(false);
}


/*******************************************************************************
 * Controller: printChecksController
 *
 * Controller for the Print view. This is the 2nd view in the app. It will
 * display the checks that have been selected to be printed, allowing the user to
 * change the start check number and pick the date to use on the checks. The
 * checks listed to print will be numbered sequentially beginning with the starting
 * check number.
 *******************************************************************************/
/* @ngInject */ function printChecksController(
  $filter,
  $location,
  $q,
  $route,
  $routeParams,
  $scope,
  $timeout,
  Alert,
  BooksSvc,
  BusyScreen,
  LocalDateSerializer,
  PrintCheckService,
  uiGridConstants,
  Session,
  MenuService
) {
  /*------------------------------------------------------*/
  /* Before attempting to populate any fields, if there's */
  /* no data to display redirect user to the main view.   */
  /*------------------------------------------------------*/
  if (
    !PrintCheckService.getBankAccount() ||
    !PrintCheckService.getChecks().length
  ) {
    $location.path('/');
    return;
  }

  /** Check Date Value. */ var mCheckDate = true;
  /** Check Number      */ $scope.checkNumber =
    PrintCheckService.getStartCheckNum();
  /** Application flags */ var appFlags = PrintCheckService.getAppFlags();

  /**
   * Setup a variable to hold the value of the print checks report checkbox. If they mark this
   * true we print a single check report for the checks they printed, only if the checks printed
   * successfully.
   */
  $scope.printChecksReport = false;

  /*--------------------------------------------------*/
  /* Hide/show the date picker based on the app flag. */
  /*--------------------------------------------------*/
  $scope.restrictCheckPrintDate = appFlags.restrictCheckPrintDate;

  /*---------------------------------------------------*/
  /* Restrict check print date to today if flag is set */
  /*---------------------------------------------------*/
  if ($scope.restrictCheckPrintDate) mCheckDate = true;

  /*--------------------------*/
  /* Print check grid options */
  /*--------------------------*/
  $scope.printChecksGrid = {
    columnDefs: [
      {
        field: 'entryDate',
        maxWidth: 150,
        displayName: 'Date',
        cellFilter: "date: 'MM/dd/yyyy'"
      },
      { field: 'paidTo', maxWidth: 300, displayName: 'Paid To' },
      { field: 'memo' },
      { field: 'amount', maxWidth: 150, cellFilter: 'currency' },
      { field: 'number', maxWidth: 200 }
    ],
    enableCellEdit: false,
    enableColumnMenus: false,
    enableFullRowSelection: true,
    enableRowHeaderSelection: true,
    enableSelectAll: false,
    isRowSelectable: function () {
      return $scope.requeue || false;
    },
    enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    onRegisterApi: function (gridApi) {
      $scope.printChecksGrid.api = gridApi;
    },
    data: []
  };

  /*****************************************************************************
   * disableRequeueBtn */
  /**
   * Returns an indication that the requeue button should be disabled. Button
   * is disabled when no checks have been selected.
   *
   * @return  Boolean   Disabled indicator
   *****************************************************************************/
  $scope.disableRequeueBtn = function () {
    return $scope.printChecksGrid.api.selection.getSelectedRows() < 1;
  };

  /*****************************************************************************
   * prevScreen */
  /**
   * Click handler for the Previous Screen button. Loads the main view when
   * clicked. The button is only visible before a check print has been attempted.
   * On the requeue screen, it is hidden.
   *****************************************************************************/
  $scope.prevScreen = function () {
    $location.path('/');
  };

  /***
   * Normally with checkbox in angularjs with a model you can just use ng-model="model" and it will automatically.
   * However there seems to be some issue with state management in this app. So I had to manually set the value
   * and directly use applyAsync to trigger a digest cycle. However there was one already occuring so I had to use
   * applyAsync to schedule the digest cycle after the current one.
   * **/
  $scope.setPrintCheckReport = function () {
    const newValue = !$scope.printChecksReport;
    $scope.printChecksReport = newValue;

    $scope.$applyAsync();
  };
  /***************************************************************************
   * printTheChecks */
  /**
   * Prints the checks.
   ***************************************************************************/
  $scope.printTheChecks = function () {
    /*-------------------------*/
    /* No date selected, exit. */
    /*-------------------------*/
    if ($scope.selectDate() === null) {
      Alert.error(
        'Please select a date to be used for the checks.',
        'No Date Selected',
        true
      );
      return;
    }

    /*-------------------*/
    /* Service call data */
    /*-------------------*/
    var acctID = PrintCheckService.getBankAccount().accountID;
    var checkNumber = $scope.checkNumber;
    var checkDate = mCheckDate ? new Date() : null;
    var checkDateStamp = LocalDateSerializer.serialize(checkDate);

    /*--------------------------------------------------*/
    /* If checks are being requeued, use only the IDs   */
    /* and count of selected checks, else this is the   */
    /* first print attempt, use all checks in the grid. */
    /*--------------------------------------------------*/
    var checkCount = $scope.printChecksGrid.data.length;
    var checkIDsIn = $scope.printChecksGrid.data.map(function (check) {
      return check.id;
    });
    var checkIDsString = checkIDsIn.join('|');

    /*---------------------------------------*/
    /* Verify the check numbers can be used. */
    /*---------------------------------------*/
    BusyScreen.setBusy(true);
    BooksSvc.verifyCheckNumbers(acctID, checkNumber, checkCount)
      .then((resp) => {
        BusyScreen.setBusy(false);
        /*--------------------------------------------*/
        /* Display print PDF in a new window on       */
        /* successful verification of checks numbers. */
        /*--------------------------------------------*/
        const checkDateStr = checkDate
          ? `${checkDate.getMonth() + 1}/${checkDate.getDate()}/${checkDate.getFullYear()}`
          : '';
        const pageURL = `PrintChecks.ashx?aid=${acctID}&ctp=${checkIDsString}&cns=${checkNumber}&cd=${checkDateStr}`;

        window.open(Session.getSessionURL(pageURL), '_blank');

        /*------------------------------------*/
        /* Redirect to Select view if user    */
        /* confirms checks printed correctly. */
        /*------------------------------------*/
        Alert.confirm(
          'Click YES to keep assigned check numbers.\n Click NO if you need to return checks to the print queue.',
          'Did your checks print successfully?'
        )
          .then(() => {
            if (!$scope.printChecksReport) {
              $location.path('/');
              return;
            }

            /***
             * You'll notice here I have to do some fancy footwork to get the URL for the CheckReport.aspx page.
             *
             * The main issue comes from the fact that if I just use Session.getSessionURL('ChecksReport.aspx') then
             * it will attach the ChecksReport.aspx to the current page. Which will fail because the current page is
             * print checks. SOOOO I have to grab the menu for the CheckReport page and then parse the URL to get all
             * but the final /index.aspx. Then I can append CheckReport.aspx to the URL and get the correct URL.
             *
             * This works this way because our report pages share the exact same url structure between the client side
             * report filtering and the actual report page. For example:
             * 1. Checks Report Filter Page: http://ws0.asbworks.loc/(S(0o1xrqqvwpm0rxsffppcs4gz))/books/client/apps/ChecksReport/index.aspx?mID=149540&20241010182159
             * 2. Checks Report Page: http://ws0.asbworks.loc/(S(0o1xrqqvwpm0rxsffppcs4gz))/books/client/apps/ChecksReport/CheckReport.aspx
             *
             * Also!!!!!! You'll notice that I create a hidden form and submit that form to the server. This is because our report pages
             * are not RESTful and require form url encoded data to be sent to the server. This is the only way to get the data to the server
             * in the correct format. All of our report pages use this exact same handler so it forced me into this situation.
             * */
            MenuService.findOption('REPORTS-CheckReport')
              .then((menuOption) => {
                // We remove: ?mID=149540&20241010182159 from the example above.
                const parts = menuOption.url.split('?');
                // We then replace: /books/client/apps/ChecksReport/index.aspx -> /books/client/apps/ChecksReport/CheckReport.aspx
                const path = parts
                  .shift()
                  .replace('index.aspx', 'CheckReport.aspx');

                const checksReport = Session.getSessionURL(path);

                const form = document.createElement('form');
                form.method = 'POST';
                form.action = checksReport;
                form.target = '_blank';

                const checkNumberInput = document.createElement('input');
                checkNumberInput.type = 'hidden';
                checkNumberInput.name = 'request';

                /***
                 * The server for the checks report expects the check numbers to be separated with commas.
                 * Example: 123,124,125
                 * **/
                const checkNumbers = $scope.printChecksGrid.data
                  .map((check) => check.number)
                  .join(',');

                /***
                 * Setup this object to be in the exact same format as what the CheckReport page submits to the server.
                 * The only values that matter are:
                 * 1. reportFormat
                 * 2. checkNumbers
                 * 3. bankID
                 *
                 * !! The date stamps can never be null when sent to server, 0 is default value for date stamps.
                 **/
                const requestObject = {
                  reportFormat: 'PDF',
                  status: 'A',
                  entityType: 0,
                  entityID: 0,
                  entityName: null,
                  startDate: null,
                  endDate: null,
                  bankID: acctID,
                  checkNumbers: checkNumbers,
                  includeDetail: true,
                  startDateStamp: 0,
                  endDateStamp: 0
                };

                /**
                 * Our server form handler actually expects the form request object to only have 1 key value pair
                 * that holds all the data. So we have to stringify the object and send it as a single key value pair.
                 *
                 * This is a strange implemenation but it is what we setup across all of our report pages.
                 */
                checkNumberInput.value = JSON.stringify(requestObject);

                form.appendChild(checkNumberInput);

                document.body.appendChild(form);
                form.submit();

                document.body.removeChild(form);
              })
              .catch((error) => {
                Alert.error(
                  `Failed to print the checks report! Error: ${resp.parsedResponse.message() || resp.statusText}`,
                  'Print Check Report Error',
                  true
                );
                console.error(error);
              })
              .finally(() => {
                $location.path('/');
              });
          })
          .catch(() => {
            $scope.requeue = true;

            /*----------------------------------------------------------------*/
            /* Enable grid row selection and row selection header visibility. */
            /*----------------------------------------------------------------*/
            $scope.printChecksGrid.enableSelectAll = true;
            $scope.printChecksGrid.api.grid.columns[0].colDef.visible = true;
            $scope.printChecksGrid.api.grid.refresh();
          });
      })
      .catch((resp) => {
        /*-------------------------------------------------------*/
        /* The print check service rejected the request. Disable */
        /* the BusyScreen and display error message to the user. */
        /*-------------------------------------------------------*/
        BusyScreen.setBusy(false);
        Alert.error(
          resp.parsedResponse.message() || resp.statusText,
          'Print Check Error',
          true
        );
      });
  };

  /*****************************************************************************
   * requeueTheChecks */
  /**
   * Resaves the checks with a zero (0) check number, signifying that it needs to
   * be printed. If the checkList has no checks remaining, we are done, and can
   * send the user back to the main screen.
   *****************************************************************************/
  $scope.requeueTheChecks = function () {
    BusyScreen.setBusy(true);

    /*------------------------------------------------------------------*/
    /* Set up all service calls and wait until all have been processed. */
    /*------------------------------------------------------------------*/
    $q.all(
      $scope.printChecksGrid.api.selection
        .getSelectedRows()
        .map(function (check) {
          return BooksSvc.requeueCheck(check.id);
        })
    )

      /*------------------------------------------------*/
      /* Returned from all service calls, we can remove */
      /* the busy screen and send back to main screen.  */
      /*------------------------------------------------*/
      .then(function (resp) {
        BusyScreen.setBusy(false);
        Alert.success('Your checks have been requeued', 'Checks');
        $location.path('/');
      });
  };

  /*****************************************************************************
   * selectDate */
  /**
   * Getter setter for the print date radio button group. The check date is null
   * (with nothing selected) by default so as to force the user to make
   * a selection. This is to prevent checks from being printed with the "wrong"
   * date.
   *
   * False = Date on check selected.
   * True  = Todays's date selected.
   * Null  = Nothing selected (default state).
   *
   * @return  value     User selection
   * @return  Date      Selected date
   *****************************************************************************/
  $scope.selectDate = function (value) {
    if (arguments.length == 0) return mCheckDate;

    mCheckDate = value;
  };

  /*****************************************************************************
   * updatePrintNumbers */
  /**
   * Called when the Start Check Number field blurs. If the input is valid, the
   * checks to be printed are numbered incrementally. If input is invalid, the
   * check numbers are cleared.
   *****************************************************************************/
  $scope.updatePrintNumbers = function () {
    /*-------------------------------------*/
    /* Reset all numbers before proceeding */
    /*-------------------------------------*/
    angular.forEach($scope.printChecksGrid.data, function (check) {
      check.number = null;
    });

    /*------------------------------------*/
    /* Abort if no start number provided. */
    /*------------------------------------*/
    if (!$scope.checkNumber) return;

    /*----------------------------------------------*/
    /* Start number is valid, update check numbers. */
    /*----------------------------------------------*/
    var count = $scope.checkNumber;
    angular.forEach($scope.printChecksGrid.data, function (check) {
      check.number = count++;
    });
  };

  /*----------------------------------------------*/
  /* Initialize the view. Load the selected bank  */
  /* account label and checks from previous view. */
  /*----------------------------------------------*/
  $scope.bankLabel = PrintCheckService.getBankLabel(
    PrintCheckService.getBankAccount()
  );
  $scope.printChecksGrid.data = PrintCheckService.getChecks();

  /*----------------------------------------------*/
  /* Update numbers for the checks to be printed. */
  /*----------------------------------------------*/
  $scope.updatePrintNumbers();

  /*-------------------------------------------------------*/
  /* Hide the rowHeaderSelection column. This has to be    */
  /* done using undocumented ui-grid properties because of */
  /* a bug in ui-grid that doesn't refresh the grid when   */
  /* the enableRowHeaderSelection property is toggled.     */
  /*-------------------------------------------------------*/
  $timeout(function () {
    $scope.printChecksGrid.api.grid.columns[0].colDef.visible = false;
    $scope.printChecksGrid.api.grid.refresh();
  });
}
  

/*******************************************************************************
 * Controller: selectChecksController
 *
 * Controller for the Select view. This is the 1st view in the app. The user can
 * select a bank account and the grid will auto populate with the available checks
 * to print for the account.
 *******************************************************************************/
/* @ngInject */ function selectChecksController(
  $filter,
  $location,
  $q,
  $route,
  $routeParams,
  $scope,
  Alert,
  BooksSvc,
  BusyScreen,
  PrintCheckService,
  uiGridConstants
) {
  /*-----------------------------------------------------------*/
  /* Reset the service when this view is loaded to restart app */
  /*-----------------------------------------------------------*/
  PrintCheckService.reset();

  /** Bank Accounts List.   */ $scope.dbBankAccounts = [];
  /** Current Bank Account. */ var mBankAccount;
  /** Control bar text      */ $scope.controlBarText = '';

  /*---------------------*/
  /* Select grid options */
  /*---------------------*/
  $scope.selectChecksGrid = {
    columnDefs: [
      {
        field: 'entryDate',
        maxWidth: 150,
        cellFilter: "date: 'MM/dd/yyyy'",
        displayName: 'Date',
        type: 'date',
        filterCellFiltered: true
      },
      { field: 'paidTo', maxWidth: 300, displayName: 'Paid To' },
      { field: 'memo' },
      {
        field: 'amount',
        maxWidth: 150,
        cellFilter: 'currency',
        type: 'number'
      }
    ],
    enableCellEdit: false,
    enableColumnMenus: false,
    enableFiltering: true,
    enableFullRowSelection: true,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    onRegisterApi: function (gridApi) {
      $scope.selectChecksGrid.api = gridApi;
    },
    data: []
  };

  /***************************************************************************
   * bankAccount */
  /**
   * Getter/setter for the bank selection. Updates the current bank account,
   * start check number and retrieves the checks available to be printed for the
   * bank account.
   *
   * @param   Object  Bank account
   * @return  Object  Bank account
   ***************************************************************************/
  $scope.bankAccount = function (bank) {
    if (arguments.length == 0) return mBankAccount;

    mBankAccount = bank;
    retrieveChecks(mBankAccount.accountID);
  };

  /***************************************************************************
   * bankLabel */
  /**
   * Label function for bank account dropdown selection. Returns a string in
   * format 'Bank Account (balance)'
   *
   * @param   Object  Bank account object
   * @return  String  Label to be displayed for the provided bank.
   ***************************************************************************/
  $scope.bankLabel = function (bank) {
    return PrintCheckService.getBankLabel(bank);
  };

  /***************************************************************************
   * chooseSelected */
  /**
   * Click handler for the Choose Selected button. Saves the selected bank
   * account and checks to the PrintCheckService, loads the Print view.
   ***************************************************************************/
  $scope.chooseSelected = function () {
    /*------------------------------------------------*/
    /* Abort the save if no checks have been selected */
    /*------------------------------------------------*/
    if ($scope.selectChecksGrid.api.selection.getSelectedRows() < 1) {
      Alert.error(
        'Please select at least one check from the list to print',
        'No checks selected',
        true
      );
      return;
    }

    /*-------------------------------------*/
    /* Save selected checks and bank       */
    /* account to service and switch views */
    /*-------------------------------------*/
    PrintCheckService.setBankAccount(mBankAccount);
    PrintCheckService.saveChecks(
      $scope.selectChecksGrid.api.selection.getSelectedRows()
    );
    $location.path('/print/');
  };

  /***************************************************************************
   * loadBankAccounts */
  /**
   * Returns a promise that will resolve when the bank accounts dataprovider
   * has been populated with a list of bank accounts sorted by account
   * name.
   *
   * @return  Promise  Promise to listen on.
   ***************************************************************************/
  var loadBankAccounts = function () {
    var defer = $q.defer();
    BusyScreen.setBusy(true);
    BooksSvc.getBankAccounts(true).then(function (resp) {
      BusyScreen.setBusy(false);
      $scope.dbBankAccounts = resp.data.sort(function (a, b) {
        return a.accountName
          .toLowerCase()
          .localeCompare(b.accountName.toLowerCase());
      });
      defer.resolve();
    });
    return defer.promise;
  };

  /***************************************************************************
   * retrieveChecks */
  /**
   * Retrieves the checks for the selected bank account and updates the control
   * bar text to reflect the results count.
   *
   * @param   accountID  Account ID
   ***************************************************************************/
  function retrieveChecks(accountID) {
    BusyScreen.setBusy(true);
    BooksSvc.getChecksToPrint(accountID).then(function (resp) {
      BusyScreen.setBusy(false);
      $scope.selectChecksGrid.data = resp.data;

      $scope.controlBarText =
        'There ' +
        ($scope.selectChecksGrid.data.length == 1 ? 'is ' : 'are ') +
        $scope.selectChecksGrid.data.length +
        ' check' +
        ($scope.selectChecksGrid.data.length == 1 ? '' : 's') +
        ' waiting to be printed';

      /*------------------------------------------------*/
      /* Clear selected rows after reloading grid data. */
      /* Bug in ui-grid can make the "select all" check */
      /* appear active even though nothing is selected. */
      /*------------------------------------------------*/
      $scope.selectChecksGrid.api.selection.clearSelectedRows();
    });
  }

  /*-------------------*/
  /* Setup Application */
  /*-------------------*/
  loadBankAccounts().then(function () {
    BusyScreen.setBusy(true);
    /*--------------------------------*/
    /* Select the first bank account. */
    /*--------------------------------*/
    if ($scope.dbBankAccounts.length > 0) {
      BooksSvc.getOrganization().then(function (resp) {
        $scope.org = resp.data;
        var bank = $scope.dbBankAccounts
          .filter(function (b) {
            return b.accountID == $scope.org.defaultBankID;
          })
          .shift();

        if (!bank && $scope.dbBankAccounts.length > 0)
          bank = $scope.dbBankAccounts[0];
        $scope.bankAccount(bank);
      });
    }
    BusyScreen.setBusy(false);
  });
}

/*****************************************************************************
 * Service: PrintCheckService
 *
 * Service to store data shared by the app and views in print checks.
 *****************************************************************************/
/* @ngInject */ function printCheckServiceFactory($filter) {
  /*--------------------------*/
  /* Internal data properties */
  /*--------------------------*/
  var appFlags = [];
  var bankAccount;
  var checks = [];
  var startCheckNum;

  /***************************************************************************
   * Data Properties
   ***************************************************************************/
  /** Accessor for the appFlags object. */
  function getAppFlags() {
    return appFlags;
  }
  function setAppFlags(value) {
    appFlags = value;
  }

  /** Accessor for the bank account. */
  function getBankAccount() {
    return bankAccount;
  }
  function setBankAccount(value) {
    bankAccount = value;
  }

  /** Accessor for the bank label. */
  function getBankLabel(bank) {
    return (
      bank.accountName + ' (' + $filter('currency')(bank.currentBalance) + ')'
    );
  }

  /** Accessor for the list of checks to print. */
  function getChecks() {
    return checks;
  }
  function saveChecks(value) {
    checks = value;
  }

  /** Accessor for the check number. */
  function getStartCheckNum() {
    return bankAccount ? bankAccount.PrintedNumber : null;
  }

  /***************************************************************************
   * reset */
  /**
   * Deletes the stored bank account, checks and start number.
   ***************************************************************************/
  function reset() {
    (bankAccount = null), (checks = []), (startCheckNum = null);
  }

  /*--------------------------------------------------*/
  /* Return the API for interacting with the service. */
  /*--------------------------------------------------*/
  return {
    getAppFlags: getAppFlags,
    getBankAccount: getBankAccount,
    getBankLabel: getBankLabel,
    getChecks: getChecks,
    getStartCheckNum: getStartCheckNum,
    saveChecks: saveChecks,
    setAppFlags: setAppFlags,
    setBankAccount: setBankAccount,
    reset: reset
  };
}
